import cx from 'classnames'

import Styles from './PhotosRow.module.scss'

import { useDebounce } from 'hooks/useDebounce'
import { useUnsplashImages } from 'hooks/queries/useUnsplashImages'
import { usePixabayElements } from 'hooks/queries/designer/usePixabayElements'

import { useImageMenuContext } from '../ImageMenuContext'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Carousel } from 'components/Carousel/Carousel'
import { SelectedImage } from 'types'
import { Button } from 'blaze-ui/Button'
import { SelectableFile } from '../SelectableFile/SelectableFile'

const PhotosRowContent = () => {
  const { searchTerm, setProvider, selectedImages, toggleSelectedImage } = useImageMenuContext()
  const debouncedQuery = useDebounce(searchTerm, 500)
  const { data: unsplashData } = useUnsplashImages({ query: debouncedQuery, perPage: 20 })
  const { data: pixabayData } = usePixabayElements({ query: debouncedQuery, pageSize: 20, imageType: 'all' })
  const unsplashResults = (unsplashData?.pages || []).flatMap((page) =>
    page?.type === 'success' ? (page.data.results || page.data) ?? [] : [],
  )
  const unsplashImages = unsplashResults.map((item) => {
    return {
      url: item.urls.regular,
      height: item.height,
      width: item.width,
      unsplash: {
        authorUsername: item.user.username,
        authorName: item.user.name,
        id: item.id,
        query: searchTerm,
      },
    }
  })
  const pixabayResults = (pixabayData?.pages || []).flatMap((page) => page.images || [])
  const pixabayImages = pixabayResults.map((item) => {
    return {
      url: item.largeImageURL,
      height: item.imageHeight,
      width: item.imageWidth,
      pixabay: {
        id: item.id,
      },
    }
  })

  const images: SelectedImage[] = []
  const maxLength = Math.max(unsplashImages.length, pixabayImages.length)

  for (let i = 0; i < maxLength; i++) {
    if (i < unsplashImages.length) {
      images.push(unsplashImages[i])
    }
    if (i < pixabayImages.length) {
      images.push(pixabayImages[i])
    }
  }

  return (
    <div className={cx(Styles.row, Styles.photosRow, Styles.container)}>
      <div className={Styles.rowHeader}>
        <Heading level={4} color="var(--dark-80)">
          Stock Photos
        </Heading>
        <Button size="sm" variant="ghost" onPress={() => setProvider('photos')} data-testid="see-all-photos-button">
          See All
        </Button>
      </div>
      <div className={Styles.carouselContainer}>
        <Carousel offset={20}>
          {images.map((image) => (
            <SelectableFile
              key={image?.pixabay?.id || image?.unsplash?.id}
              onSelect={() => toggleSelectedImage({ ...image, provider: 'stockPhoto' })}
              isSelected={selectedImages.some((i) => i.url === image.url)}
            >
              <img src={image.url} alt="" />
            </SelectableFile>
          ))}
        </Carousel>
      </div>
    </div>
  )
}

export const PhotosRow = () => {
  const { hiddenProviders } = useImageMenuContext()

  if (hiddenProviders.includes('stockPhoto')) return null

  return <PhotosRowContent />
}
